import { Tooltip } from "antd";
import React from "react";

const PdfLink = ({ text, data }) => {
  const tooltipText = data?.status === "pending" ? "Not signed" : "Signed";

  return (
    <Tooltip placement="top" title={tooltipText}>
      <a
        href={data.url}
        target="_blank"
        rel="noopener noreferrer"
        className={`font-semibold underline ${
          data?.status === "pending" ? "text-primary" : "text-green-600"
        }`}
      >
        {text}
      </a>
    </Tooltip>
  );
};

export default PdfLink;
